import { FetchError } from "@/core/fetch"

export class ValidationError extends Error {
  readonly reporter = "client:validation"

  constructor(message: string) {
    super(message)
  }
}

export function errorMessage(error: Error, msg?: string): string {
  if (!(error instanceof FetchError)) {
    return msg ?? error.message
  }
  const parts = [msg ?? error.message]
  if (error.url) {
    parts.push(`url: ${error.url}`)
  }
  if (error.response?.status) {
    parts.push(`status: ${error.response.status}`)
  }
  if (error.response?.statusText) {
    parts.push(`statusText: ${error.response.statusText}`)
  }
  if (!error.response) {
    parts.push("response: none")
  }
  return parts.join(", ")
}

// check to ensure that the thrown errror is not already logged with logger
// Some of the nosto-api errors are logged immediately due to unhandled promise rejections not propagating
// e.g. nostojs(api => { api.defaultSession().viewProduct().load() })
export function isAlreadyLogged(err: unknown) {
  return err instanceof ValidationError
}
